import { fetchAuthSession, signOut } from 'aws-amplify/auth';

export async function storeAccessToken() {
  try {
    const session = await fetchAuthSession();
    const accessToken = session.tokens?.accessToken?.toString();
    const idToken = session.tokens?.idToken?.toString();
    const groups = session.tokens?.idToken?.payload?.['cognito:groups'] || [];

    if (accessToken && idToken) {
      sessionStorage.setItem('accessToken', accessToken);
      sessionStorage.setItem('CognitoAuthToken', JSON.stringify({ idToken }));
      sessionStorage.setItem('CognitoUserGroups', JSON.stringify(groups));
    } else {
      console.warn('⚠️ Missing tokens in session response');
    }
  } catch (error) {
    console.error('❌ Failed to fetch session:', error);
    throw error;
  }
}

export async function validateAndRefreshTokens() {
  try {
    const session = await fetchAuthSession({ forceRefresh: true });
    if (session.tokens?.accessToken) {
      await storeAccessToken();
      return true;
    }
    return false;
  } catch (error) {
    console.error('❌ Token validation failed:', error);
    await clearAllTokens();
    return false;
  }
}

export async function clearAllTokens() {
  // Clear session storage
  sessionStorage.clear();
  
  // Clear Cognito tokens from local storage
  for (let key in localStorage) {
    if (key.startsWith('CognitoIdentityServiceProvider')) {
      localStorage.removeItem(key);
    }
  }
  
  console.log('🧹 All tokens cleared');
}

export async function handleAuthError() {
  try {
    await signOut();
  } catch (error) {
    console.error('SignOut error:', error);
  } finally {
    await clearAllTokens();
  }
}
